import { nullish } from "components/OptionsWizard/WizardContext";
import { ICADLayer } from "../../interfaces";

export const GlassLayerIcon: React.FC<{ layer: ICADLayer | nullish }> = ({ layer }) => {

    if (!layer)
        return <></>;

    return <div style={{
        width: "32px",
        height: "32px",
    }}>
        <div style={{
            margin: "2.5px",
            width: "27px",
            height: "27px",
            border: "1.5px solid black",
            borderRadius: "6px",
            background: `linear-gradient(to right, ${layer.colors.start}, ${layer.colors.end})`,
            display: "inline-block",
        }} />

    </div>

}